import { SLIDERS } from '../config/sliders.js';
import { UI_METRICS } from '../config/uiMetrics.js';
import { getDraftLongEdgePx, isLegacyHighresDraftToggleOn, resolveDraftScale } from '../draft_state.js';

function resolveScale(origW, origH) {
    return resolveDraftScale(origW, origH) || 1.0;
}

export function updateStats(origW, origH) {
    const finalSize = document.getElementById('finalSize');
    const mpEl = document.getElementById('totalMP');
    const rowEl = document.getElementById('rowCount');
    const tileEl = document.getElementById('tileCount');
    const fileSize = document.getElementById('fileSize');

    if (!origW || !origH) {
        if (finalSize) finalSize.innerText = '-';
        if (mpEl) mpEl.innerText = '-';
        if (rowEl) rowEl.innerText = '-';
        if (tileEl) tileEl.innerText = '-';
        if (fileSize) fileSize.innerText = '-';
        return;
    }
    const tileInput = document.getElementById('thInput');
    if (!tileInput) return;
    const scale = resolveScale(origW, origH);
    const tileHeightDefault = SLIDERS.tileHeight.defaultValue;
    const tileHeight = parseInt(tileInput.value, 10) || tileHeightDefault;

    const scaleVal = document.getElementById('scaleVal');
    if (scaleVal) {
        if (isLegacyHighresDraftToggleOn()) {
            scaleVal.innerText = scale.toFixed(2) + "x";
        } else {
            scaleVal.innerText = `${getDraftLongEdgePx()}px fixed`;
        }
    }

    const finalW = Math.round(origW * scale);
    const finalH = Math.round(origH * scale);
    const mp = (finalW * finalH) / 1_000_000;
    const totalRows = Math.ceil(finalH / tileHeight);
    const totalCols = Math.ceil(finalW / tileHeight);
    const totalTiles = totalRows * totalCols;

    if (finalSize) finalSize.innerText = `${finalW.toLocaleString()} x ${finalH.toLocaleString()} px`;
    if(mpEl) mpEl.innerText = `${mp.toFixed(1)} MP`;

    if (rowEl) rowEl.innerText = `${totalRows.toLocaleString()}`;
    if (tileEl) tileEl.innerText = `~${totalTiles.toLocaleString()}`;
    if (fileSize) fileSize.innerText = `~${(mp * UI_METRICS.ESTIMATED_MB_PER_MP).toFixed(1)} MB`;
}
